import { useEffect } from "react";
import classes from "../../component/viewplans/ViewPlans.module.css";
import handshake from "../../assets/images//handshake.jpg";
import starter from "../../assets/images//starter.jpg";
import DoneTick from "../../assets/images/DoneTick.png";
import CommonLayout from "../commoncomponents/layout/CommonLayout";
import ButtonComponent from "../commoncomponents/buttons/ButtonComponent";
import { setSnackbar } from "../commoncomponents/alert/SnackbarAction";
import { getRequest } from "../../api/AxiosAPICall";
import { Divider, Grid, Box, Typography, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const freemiumFeatures = [
  { featureId: "1", featureDescription: "E-Appointments-Online Bookings" },
  {
    featureId: "2",
    featureDescription: "Patient Administration and Scheduling",
  },
  { featureId: "3", featureDescription: "Electronic Patient Record" },
  { featureId: "4", featureDescription: "Patient Billing" },
  { featureId: "5", featureDescription: "Patient E-Communication" },
  { featureId: "6", featureDescription: "Telemedicine (Online Consultations)" },
  { featureId: "7", featureDescription: "E-Prescriptions and Pharmacy" },
  { featureId: "8", featureDescription: "Payment Portal" },
];

const premiumFeatures = [
  { featureId: "1", featureDescription: "E-Appointments-Online Bookings" },
  {
    featureId: "2",
    featureDescription: "Patient Administration and Scheduling",
  },
  { featureId: "3", featureDescription: "Electronic Patient Record" },
  { featureId: "4", featureDescription: "Patient Billing" },
  { featureId: "5", featureDescription: "Patient E-Communication" },
  { featureId: "6", featureDescription: "Telemedicine (Online Consultations)" },
  { featureId: "7", featureDescription: "E-Prescriptions and Pharmacy" },
  { featureId: "8", featureDescription: "Payment Portal" },
  { featureId: "9", featureDescription: "Referral Portal" },
  { featureId: "10", featureDescription: "Document Management" },
  { featureId: "11", featureDescription: "Customised Assessments and Letters" },
  { featureId: "11", featureDescription: "Online Patient Assessment" },
];

const ViewPlans = (props: any) => {
  let history = useNavigate();
  const dispatch = useDispatch();

  const fetchCellmaPreference = async () => {
    await getRequest("cellmaflexPreferences", {
      params: {
        cecName: "cellmaflex_premium_cost",
      },
    }).then((response) => {
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        //set price if needed
        console.log("Price: ", response?.data);
      }
    });
  };

  useEffect(() => {
    fetchCellmaPreference();
  }, []);

  return (
    <CommonLayout footer={true} showHeaderNavigation={true} isLogedIn={true}>
      <Box textAlign={"center"}>
        <Box>
          <Typography
            component="div"
            variant="h2"
            gutterBottom
            style={{ paddingTop: "5px" }}
            className={classes.headingH2}
            sx={{ fontSize: { md: "34px", xs: "26px" } }}
          >
            Pick Your Premium
          </Typography>
          <Typography variant="h6" className={classes.headingH6}>
            Choose a plan that suits you best and elevates your experience by
            unlocking exclusive features
          </Typography>
        </Box>
        <br />
        <Box display={"flex"}>
          <Grid container padding={"8px"}>
            {/*First Grid Item below */}
            <Grid item xs={12} sm={6} marginBottom={{ xs: "80px", md: "0" }}>
              <Stack className={classes.plansContainer}>
                <Box display={"flex"} justifyContent={"space-between"}>
                  <ButtonComponent
                    buttontitle="Premium"
                    sx={{
                      width: "150px",
                      height: "50px",
                      borderRadius: "6px",
                      backgroundColor: "#3CB54A",
                      fontSize: "20px !important",
                      textTransform: "capitalize",
                      "&:hover": { backgroundColor: "#00c04b" },
                    }}
                    label="Freemium"
                    size="medium"
                  />
                  <img
                    src={starter}
                    alt="freemium"
                    className={classes.plansIcon}
                  />
                </Box>
                <Divider sx={{ marginTop: "20px" }} />
                <Box display={"flex"} flexDirection={"column"}>
                  {freemiumFeatures.map((freemiumItem) => (
                    <Box
                      display={"flex"}
                      className={classes.freemiumFeatures}
                      key={freemiumItem.featureId}
                    >
                      <img
                        src={DoneTick}
                        alt="Tick Icon"
                        className={classes.tickIcon}
                      />
                      <Typography sx={{ fontSize: "18px !important" }}>
                        {freemiumItem.featureDescription}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Stack
                  sx={{ marginTop: { xs: "20px", sm: "240px", md: "220px" } }}
                  alignItems={"center"}
                  width={"100%"}
                >
                  <Divider sx={{ marginBottom: "20px", width: "100%" }} />
                  <ButtonComponent
                    buttontitle="Premium"
                    sx={{
                      width: {
                        xs: "280px !important",
                        sm: "320px !important",
                        md: "420px !important",
                      }, // Set width to 100% to span the container size
                      height: "50px",
                      borderRadius: "6px",
                      backgroundColor: "#117CB1",
                      fontSize: "18px !important",
                      textTransform: "capitalize",
                    }}
                    label="Get Started"
                    size="medium"
                    onClick={() => {
                      history("/organization");
                    }}
                  />
                </Stack>
              </Stack>
            </Grid>
            {/*Second Grid Item below */}
            <Grid item xs={12} sm={6}>
              <Stack className={classes.plansContainer} spacing={2}>
                <Box display={"flex"} justifyContent={"space-between"}>
                  <ButtonComponent
                    buttontitle="Premium"
                    sx={{
                      width: "150px",
                      height: "50px",
                      borderRadius: "6px",
                      backgroundColor: "#117CB1",
                      fontSize: "20px !important",
                      textTransform: "capitalize",
                      "&:hover": {},
                    }}
                    label="Premium"
                    size="medium"
                  />
                  <img
                    src={handshake}
                    alt="Premium"
                    className={classes.plansIcon}
                  />
                </Box>
                <Divider sx={{ marginTop: "20px" }} />
                <Box display={"flex"} flexDirection={"column"}>
                  {premiumFeatures.map((freemiumItem) => (
                    <Box
                      display={"flex"}
                      className={classes.freemiumFeatures}
                      key={freemiumItem.featureId}
                    >
                      <img
                        src={DoneTick}
                        alt="Tick Icon"
                        className={classes.tickIcon}
                      />
                      <Typography sx={{ fontSize: "18px !important" }}>
                        {freemiumItem.featureDescription}
                      </Typography>
                    </Box>
                  ))}
                </Box>
                <Stack sx={{ marginTop: "20px" }} alignItems={"center"}>
                  <Divider sx={{ marginBottom: "20px", width: "100%" }} />
                  <ButtonComponent
                    buttontitle="Premium"
                    sx={{
                      width: {
                        xs: "280px !important",
                        sm: "320px !important",
                        md: "420px !important",
                      },
                      borderRadius: "6px",
                      backgroundColor: "#FFFFFF !important",
                      fontSize: "18px !important",
                      textTransform: "capitalize",
                      "&:hover": { backgroundColor: "#1A5D1A" },
                      border: "1px solid #BDBDCE !important",
                      color: "#BDBDCE !important",
                    }}
                    label="Get Started"
                    size="medium"
                    disabled={true}
                  />
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </CommonLayout>
  );
};

export default ViewPlans;
